import * as aiqConfig from 'config';

export const CLIENT_MODE = { VIDEO_WALL: 'videoWall', RECEIVING_TRANSACTIONS: 'receivingTransactions' };

const modeConfig = {
    [CLIENT_MODE.VIDEO_WALL]: {
        sessionStorageKey: aiqConfig.sessionStorageKeys.videoWallEnabled,
        defaultState: aiqConfig.transactionPageDefaultMode.videoWallEnabled,
    },
    [CLIENT_MODE.RECEIVING_TRANSACTIONS]: {
        sessionStorageKey: aiqConfig.sessionStorageKeys.receivingTransactionsEnabled,
        defaultState: aiqConfig.transactionPageDefaultMode.receivingTransactionsEnabled,
    },
};

/**
 * Resolve the enabled/disabled state for a client mode.
 *
 * When a valid URL param (`sessionStorageKey`) is present it is persisted to sessionStorage
 * and returned. Only the exact strings `'true'` and `'false'` are accepted - any other value
 * (e.g. `'1'`, `'TRUE'`, empty string) is ignored and the function falls through to
 * sessionStorage / the compiled-in default. This avoids silently treating invalid values
 * as `false`.
 *
 * Note: this function has a side-effect (sessionStorage.setItem). It is called both from the
 * transactionsSlice initialState (module-eval time) and from TransactionPage's mount effect;
 * whichever runs first seeds sessionStorage and both then agree on the value.
 */
export function resolveClientMode(mode) {
    const { sessionStorageKey, defaultState } = modeConfig[mode];

    const urlValue = new URLSearchParams(window.location.search).get(sessionStorageKey);
    if (urlValue === 'true' || urlValue === 'false') {
        const enabled = urlValue === 'true';
        sessionStorage.setItem(sessionStorageKey, JSON.stringify(enabled));
        return enabled;
    }

    const sessionConfig = sessionStorage.getItem(sessionStorageKey);
    return sessionConfig ? JSON.parse(sessionConfig) : defaultState;
}
